import { render, staticRenderFns } from "./iybr-compensation-table.vue?vue&type=template&id=34a0a488"
import script from "./iybr-compensation-table.ts?vue&type=script&lang=ts&external"
export * from "./iybr-compensation-table.ts?vue&type=script&lang=ts&external"
import style0 from "./iybr-compensation-table.scss?vue&type=style&index=0&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('34a0a488')) {
      api.createRecord('34a0a488', component.options)
    } else {
      api.reload('34a0a488', component.options)
    }
    module.hot.accept("./iybr-compensation-table.vue?vue&type=template&id=34a0a488", function () {
      api.rerender('34a0a488', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/in-year-budget-requests/create-in-year-budget-request/create-iybr-form/iybr-compensation-table/iybr-compensation-table.vue"
export default component.exports